import React, { useEffect, useState } from 'react';
import CarsClient from './CarClient';
import { useCarData } from '../hooks/useCarData';
import { useTranslation } from '../hooks/useTranslation';

// A helper to read URL params in plain React
function useQueryParams() {
  const [params, setParams] = useState(new URLSearchParams(window.location.search));

  useEffect(() => {
    const handlePopState = () => {
      setParams(new URLSearchParams(window.location.search));
    };
    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);
  //console.log("params ============> ",params);
  for (const [key, value] of params.entries()) {
  //console.log(key, value);
}
  return params;
}

export default function CarsPage() {
  const { t } = useTranslation();
  const searchParams = useQueryParams();

  // Extract filters from searchParams
  const per_page = parseInt(searchParams.get('per_page') || '20');
  const page = parseInt(searchParams.get('page') || '1');
  const brand_ids = searchParams.getAll('brand_ids[]');
  const body_type_ids = searchParams.getAll('body_type_ids[]');
  const color_ids = searchParams.getAll('color_ids[]');
  const fuel_type = searchParams.get('fuel_type') || '';
  const search = searchParams.get('search') || '';
  const sort_by = searchParams.get('sort_by') || '';
  const transmission = searchParams.getAll('transmission');
  //console.log("brand ids ===============> ". searchParams);

  const { carsData, filtersData, popularCarsData, loading, error } = useCarData({
    per_page,
    page,
    brand_ids,
    body_type_ids,
    color_ids,
    fuel_type,
    search,
    sort_by,
    transmission,
    currency: 'usd',
  });

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-red-500 mb-4">{t('extra.error_loading')}</h2>
          <p className="text-gray-600">{t('extra.try_refresh')}</p>
        </div>
      </div>
    );
  }

  return (
    <CarsClient 
      initialCars={carsData?.data || carsData || []}
      cFilters={filtersData?.data || filtersData || {}}
      popularCarsData={popularCarsData?.data || popularCarsData || []}
      homeData={carsData}
      initialSearchParams={{
        brand_ids,
        body_type_ids,
        color_ids,
        fuel_type,
        search,
        sort_by,
        transmission,
        per_page,
        page
      }}
    />
  );
}
